import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6b3b7f4a&"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js&"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports